import { EventForm } from "../../components";
import { TenantGateBanner, TenantGateLock, useTenantGate } from "../../components/ui";

/**
 * Sin <Breadcrumb> propio: /events/new está en el menú ("Eventos → Agregar
 * evento"), así que lo cubre <AutoBreadcrumb> desde el navModel. Tener los dos
 * mostraba dos migas apiladas.
 */
export const NewEvent = () => {
  const gate = useTenantGate();

  return (
    <div className="p-card gap-4 p-3">
      <h1 className="text-center text-3xl">Crear Evento</h1>
      {/* §6.4 — el formulario hereda el tenant del header; con "Todos" no hay
          a quién asignar el evento y la creación se bloquea. */}
      <TenantGateBanner action="crear el evento" gate={gate} />
      <TenantGateLock gate={gate}>
        <EventForm />
      </TenantGateLock>
    </div>
  );
};
